import ActiveItemsCard from "../ActiveItemsCard";
import { LoadingCard } from "../LoadingCard";
import { EmptyCard } from "./EmptyCard";

type ActiveCostAnomaliesCardProps = {
  numberOfAnomalies: number;
  numberOfAnomaliesInLast30Days: number;
  loading: boolean;
  anomaliesAtRisk: number;
};

export const ActiveCostAnomaliesCard = ({
  numberOfAnomalies,
  numberOfAnomaliesInLast30Days,
  loading,
  anomaliesAtRisk,
}: ActiveCostAnomaliesCardProps) => {
  if (loading) {
    return <LoadingCard title="Active cost anomalies" />;
  }

  if (anomaliesAtRisk === 0 || !anomaliesAtRisk) {
    return <EmptyCard title="Active cost anomalies" />;
  }

  return (
    <ActiveItemsCard
      title="Active cost anomalies"
      value={numberOfAnomalies}
      cloudCostsAtRisk={anomaliesAtRisk}
      dataIcon="trending up"
      trend={numberOfAnomaliesInLast30Days ?? 0}
      trendColor="error.main"
      trendDate="30 days"
      buttonLink="./monitor/cost-anomalies"
    />
  );
};
